import * as React from "react";
import LinkComp from "../LinkComp";
import Icon from "../Icon";
import Alert from "../Alert";
import Tabs from "../Tabs";
import svgSortAsc from "../../svgs/arrow-up.svg";
import "./CRUD.scss";

const CRUD = ({tabsData, currentPageRef = null, drawer = null, backLink, edit, children = null, state, setState, handleSubmit, extraHeaderInfo, extraInfo = null, type = "", backName = "", isAgent = false, saveData, title = "", formattedOriginalData = null, tabsClass = ''}) => {
    const {data, viewMode, success, error, errorTabs, currentTab} = state;

    const toggleDelete = () => {
        if (!data.DELETED) {
            data.DELETED = "1";
            setState({data}, saveData);
        } else {
            data.DELETED = null;
            setState({data}, saveData);
        }
    };

    if (data === null) {
        return <div>Loading...</div>;
    } else if (data === false) {
        return (
            <Alert type="warn">
                {`${type.charAt(0).toUpperCase()}${type.slice(1)} not found`}
            </Alert>
        );
    } else {
        return (
            <div className="CRUD" ref={currentPageRef}>
                {drawer}
                <div className="CRUD_content">
                    <div className="page-rounded-corner-container">
                        <div className="page-header-container list">
                            <div className="page-back-button" onClick={() => {history.back()}}>
                                <Icon svg={svgSortAsc}/>
                                {backName}
                            </div>
                            <div className="page-header">
                                <div className="page-title">{edit ? title : "Add " + type}</div>
                                {edit ? (
                                    <button className="button-new negative"
                                            onClick={() => {
                                                !viewMode &&
                                                setState((prevState) => ({
                                                    viewMode: true,
                                                    data: formattedOriginalData
                                                        ? {...formattedOriginalData}
                                                        : {...prevState.original},
                                                }));
                                                viewMode && toggleDelete();
                                            }}
                                    >
                                        {viewMode && data.ARCIMEDES_ROW_ID
                                            ? data && data.DELETED === "1"
                                                ? "Undelete"
                                                : "Delete"
                                            : "Cancel"}
                                    </button>
                                ) : (
                                    <LinkComp to={backLink}>
                                        <button className="button-new negative">Cancel</button>
                                    </LinkComp>
                                )}
                                <button
                                    form={`${type}-form`}
                                    type="submit"
                                    disabled={isAgent || data.DELETED === "1"}
                                    className={`button-new positive ${
                                        data.DELETED === "1" ? "inactive" : ""
                                    }`}
                                >
                                    {edit ? (viewMode ? "Edit" : "Save") : "Add"}
                                </button>
                                {extraHeaderInfo}
                            </div>
                        </div>
                    </div>
                    <div className={`page-body-container crud ${type === 'property' ? 'property' : ''}`}>
                        {success ? <Alert type="success">{success}</Alert> : null}
                        {error ? <Alert type="error">{error}</Alert> : null}
                        {errorTabs.length > 0 && currentTab !== 0 ? (
                            <Alert type="error">
                                Unable to add {type} because you have an empty mandatory field
                                on another tab.
                            </Alert>
                        ) : null}

                        <form onSubmit={handleSubmit} id={`${type}-form`} className='form-container'>
                            <Tabs
                                onChangeTab={(tab) => setState({currentTab: tab})}
                                errorTabs={errorTabs}
                                tabsData={tabsData}
                                className={tabsClass}
                            />
                        </form>

                        {extraInfo &&
                            <div className='CRUD_content_extra_info'>
                                <div className='line'/>
                                {extraInfo}
                            </div>
                        }
                    </div>
                </div>
                {children}
            </div>
        );
    }
};

export default CRUD;
